export enum EHiveModel {
  HIVE1 = 'hive1',
  HIVE1C = 'hive1c',
  HIVE1C_PLUS = 'hive1c+',
  HIVE2 = 'hive2',
  HIVE3 = 'hive3',
  UNKNOWN = 'unknown',
}

export type THive = {
  id: string;
  serial_number: string;
  num_sensors?: number;
};
